import React from "react";
import { Col, Container, Nav, Placeholder, Row } from "react-bootstrap";

const Footer: React.FC = () => {
    return (
        <Container fluid  className="footer pt-5">
            <Row>
                <Col md="12" lg="6" className="my-auto text-center pb-5">RIUDICC</Col>
                <Col md="12" lg="6" className="pb-5 customCE"><Nav.Link href="https://commission.europa.eu/index_en" target="_blank"><img style={{width: "30%"}} src="/images/comisioneuropea.png" /></Nav.Link></Col>
            </Row>
        </Container>
    )
}

export default Footer;